import CustomList from '../../../../core/components/core/Util/List/CustomList/CustomList';
import CustomListContainer from '../../../../core/components/core/Util/List/CustomList/CustomListContainer';
import config from '../../../config/config';
import Fetch from '../../../../core/util/core/Fetch';
import Toast from '../../../../core/components/core/Util/Toast/Toast';
import { chooseProfileFilter } from '../../../helpers/chooseProfileFilter';
import { loadData } from '../../../../core/components/core/Util/List/CustomList/loadData';

function List() {
    const profileFilter = chooseProfileFilter();

    const pathFrontEnd = '/behavioralcompetencies/';
    const paths = {
        pathAdd: pathFrontEnd + 'add',
        pathEdit: pathFrontEnd + 'edit',
        pathView: pathFrontEnd + 'view',
        endpointGetAllEntities: config.endpoints.backend + 'entities/getall',
        endpointDelete: `${config.endpoints.backend}behavioralcompetencies/delete`,
        endpointSave: config.endpoints.backend + 'behavioralcompetencies/save',
        endpoint: config.endpoints.backend + 'behavioralcompetencies/getall'
    }

    const filters = {
        validateOnChange: true,
        showGoBackButton: false,
        showSubmitButton: false,
        handleSubmit: loadData,
        fields: [
            {
                name: 'pdc_entity_id',
                type: 'select',
                label: 'Entidade',
                options: [],
                optionsEndpoint: {
                    endpoint: paths.endpointGetAllEntities,
                    label: 'corporate_name',
                    value: 'id',
                    params: {
                        filter: {
                            ...profileFilter
                        }
                    }
                },
                validations: {
                    required: false
                },
                columnSize: 3,
            },
            {
                name: 'filtro',
                type: 'submit',
                label: 'Pesquisar',
                columnSize: 1
            },
            {
                name: 'reset',
                type: 'reset',
                label: 'Limpar',
                columnSize: 2
            },
        ]
    }

    let list = {
        labelTitle: 'Competências Comportamentais',
        labelTitleButtonAdd: 'Incluir nova competência comportamental',
        fieldsShowOnDelete: ['name'],
        showPrintButtons: true,
        formFilters: (!profileFilter.pdc_entity_id && !profileFilter.pdc_project_ids) ? filters : null,
        filter: {
            ...profileFilter
        },
        columns: [
            {
                name: 'entity',
                label: 'Entidade'
            },
            {
                name: 'name',
                label: 'Nome da Competência'
            }
        ],
        columnsButtons: [
            {
                buttons: [
                    {
                        width: '10%',
                        label: 'Status',
                        type: 'switch',
                        fieldValue: 'status',
                        disabled: !!profileFilter.pdc_project_ids,
                        onChange: async (element, item) => {
                            try {
                                item.status = element.target.checked ? '1' : '0';
                                await Fetch.put(paths.endpointSave, item);
                                if (element.target.checked) {
                                    Toast.success('Competência ativada com sucesso');
                                } else {
                                    Toast.error('Competência desativada');
                                }
                            } catch (e) {
                                Toast.error(e);
                            }
                        }
                    }
                ]
            }
        ],
        ...(profileFilter.pdc_project_ids ? { canAdd: false, canEdit: false, canDelete: false } : {})
    };

    list = { ...list, ...paths };

    return (
        <div>
            <CustomListContainer
                pathAdd={list.pathAdd}
                labelTitle={list.labelTitle}
                labelTitleButtonAdd={list.labelTitleButtonAdd}
                list={list}
                content={<CustomList list={{ ...list, ...paths }} />}
            />
        </div>
    );
}
export default List;
